import productDescriptionVariantStyles from "@tps/App/SharedStyles/ProductDescriptionStyles";
import { pageTitleStyles } from "@tps/Overrides/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    variant: "h1",
    ...productDescriptionVariantStyles.medium?.productDetailDescription,
    css: css`
        ${productDescriptionVariantStyles.medium?.productDetailDescription?.css}
        margin-bottom: 0;
    `,
};

pageTitleStyles.brandStyles = {
    nameText: {
        size: 16,
        weight: "normal",
        css: css`
            width: auto;
        `,
    },
    nameLink: {
        css: css`
            width: auto;
        `,
        typographyProps: {
            size: 16,
            weight: "normal",
        },
    },
};
